/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PairingValidationAuthorizationRequestSpec { 
    /**
     * Agent Id
     */
    agent_id?: string;
    /**
     * Organidation Id
     */
    org_id: string;
    /**
     * User code to be authorized
     */
    user_code?: string;
}

